<div
  [ngClass]="isAuthenticated() ? 'h-dvh max-h-dvh min-h-dvh' : 'min-h-screen items-center justify-center'"
  class="overflow-hidden layout-wrapper relative flex w-full flex-col md:flex-row"
>
  <ng-template #layoutCompanySelect>
    <proffeo-ui-select
      (click)="turnOffMenuAutoclose()"
      (valueChange)="onCompanySelected($event)"
      [compareWith]="compareCompanies"
      [options]="companyOptions()"
      [placeholder]="'menu-select-company-dropdown-placeholder'"
      [showTriggerChevron]="true"
      [translateLabels]="false"
      [value]="activeCompany()"
      appearance="inline"
      class="layout-menu-select w-full min-w-0 flex-1"
    />
  </ng-template>

  <ng-template #layoutProjectSelect>
    <proffeo-ui-select
      (click)="turnOffMenuAutoclose()"
      (valueChange)="onProjectSelected($event)"
      [compareWith]="compareProjects"
      [options]="projectOptions()"
      [placeholder]="'menu-select-project-dropdown-placeholder'"
      [showTriggerChevron]="true"
      [translateLabels]="false"
      [value]="activeProject()"
      appearance="inline"
      class="layout-menu-select w-full min-w-0 flex-1"
    />
  </ng-template>
  <div class="shrink-0">
    @if (isAuthenticated() && isMobile()) {
      <proffeo-active-timer-bar></proffeo-active-timer-bar>
    }

    @if (isAuthenticated()) {
      <div
        class="bg-proffeo-surface-inverse flex h-[60px] min-h-[60px] w-full items-center justify-between px-3 md:hidden"
      >
        <mat-icon
          (click)="toggleMenu()"
          [fontIcon]="pinned() ? 'menu_open' : 'menu'"
          class="icon-white"
        />
        <div class="flex w-full gap-1.5 items-center justify-center max-w-[80%]">
          @if (activeCompany(); as company) {
            <p class="text-proffeo-on-action opacity-90 truncate max-w-[40%] sm:max-w-[50%]">
              {{ company.name }}
            </p>
          }
          @if (activeProject(); as project) {
            <p class="text-proffeo-on-action opacity-90 truncate max-w-[50%] sm:max-w-[75%]">- {{ project.name }}</p>
          }
        </div>
        <mat-icon
          [matMenuTriggerFor]="userMenu"
          fontIcon="account_circle"
          class="icon-white"
        />
      </div>
    }
  </div>

  <div class="layout-body relative flex flex-1 overflow-hidden">
    @if (isAuthenticated()) {
      @if (pinned()) {
        <div
          class="layout-menu-container w-screen z-120 overflow-y-auto menu-wrapper bg-proffeo-surface-inverse p-5 md:hidden"
        >
          <div class="flex flex-col w-full gap-2 pb-3">
            <div class="group flex h-[38px] cursor-pointer items-center gap-2">
              <mat-icon
                fontIcon="domain"
                class="transition-all! opacity-75 group-hover:opacity-100 icon-white"
              />
              <ng-container *ngTemplateOutlet="layoutCompanySelect" />
            </div>

            @if (projects()?.length > 0 && activeCompany()) {
              <div class="group flex h-[38px] cursor-pointer items-center gap-2">
                <mat-icon
                  fontIcon="task_alt"
                  class="transition-all! opacity-75 group-hover:opacity-100 icon-white"
                />
                <ng-container *ngTemplateOutlet="layoutProjectSelect" />
              </div>
            }
          </div>

          <!--        App Section-->
          <div class="flex h-full w-full flex-col gap-5">
            @if (dashboardMenuItems(); as dashboardMenu) {
              <div class="flex flex-col justify-center gap-2">
                <div class="flex h-[21px] w-full items-center justify-center gap-2 opacity-75">
                  <div class="flex h-full w-full items-center justify-center gap-2">
                    <span class="h-px w-full bg-proffeo-on-action/20"></span>
                    <p class="text-nowrap text-base text-proffeo-on-action">
                      {{ dashboardMenu.titleTranslationKey | translate }}
                    </p>
                    <span class="h-px w-full bg-proffeo-on-action/20"></span>
                  </div>
                </div>
                <div class="flex flex-col justify-center gap-2">
                  @for (item of dashboardMenu.children; track $index) {
                    <div
                      (click)="!item.disabled && handleNavigationClick()"
                      [ngClass]="{
                        'cursor-pointer hover:opacity-100 opacity-75': !item.disabled,
                        'opacity-25 cursor-default': item.disabled,
                        'opacity-100': isMenuItemActive(item.link)
                      }"
                      [routerLink]="item.disabled ? null : item.link"
                      [routerLinkActiveOptions]="{ exact: item.exactMatch ?? false }"
                      [matTooltip]="item.disabled ? (item.disabledTooltipTranslationKey | translate) : ''"
                      [matTooltipDisabled]="!item.disabled"
                      routerLinkActive
                      class="group flex h-[38px] cursor-pointer items-center gap-2"
                    >
                      <mat-icon
                        [fontIcon]="item.icon"
                        [class.opacity-100]="isMenuItemActive(item.link)"
                        class="transition-all! opacity-75 icon-white"
                      />
                      <p class="truncate text-nowrap text-proffeo-on-action">
                        {{ item.titleTranslationKey | translate }}
                      </p>
                    </div>
                  }
                </div>
              </div>
            }

            <!--          Project section-->
            @if (activeProjectMenuItems(); as projectMenu) {
              <div class="flex flex-col justify-center gap-2">
                <div class="flex h-[21px] w-full items-center justify-center gap-2 opacity-75">
                  <div class="flex h-full w-full items-center justify-center gap-2">
                    <span class="h-px w-full bg-proffeo-on-action/20"></span>
                    <p class="text-nowrap text-base text-proffeo-on-action">
                      {{ projectMenu.titleTranslationKey | translate }}
                    </p>
                    <span class="h-px w-full bg-proffeo-on-action/20"></span>
                  </div>
                </div>
                <div class="flex flex-col justify-center gap-2">
                  @for (item of projectMenu.children; track $index) {
                    <div
                      (click)="handleNavigationClick()"
                      [ngClass]="
                        isMenuItemActive(item.link) ? 'font-semibold text-proffeo-on-action opacity-100' : 'opacity-75'
                      "
                      [routerLink]="$safeNavigationMigration(item?.link)"
                      [routerLinkActiveOptions]="{ exact: item.exactMatch ?? false }"
                      routerLinkActive
                      class="group flex h-[38px] cursor-pointer items-center gap-2 hover:opacity-100"
                    >
                      <span>
                        <mat-icon
                          [fontIcon]="item.icon"
                          [class.opacity-100]="isMenuItemActive(item.link)"
                          class="transition-all! opacity-75 group-hover:opacity-100 icon-white"
                        />
                      </span>
                      <p class="truncate text-nowrap text-proffeo-on-action">
                        {{ item.titleTranslationKey | translate }}
                      </p>
                    </div>
                  }
                </div>
              </div>
            }

            <!--          Company Section-->
            @if (activeCompanyMenuItems(); as companyMenu) {
              <div class="flex flex-col justify-center gap-2">
                <div class="flex h-[21px] w-full items-center justify-center gap-2 opacity-75">
                  <div class="flex h-full w-full items-center justify-center gap-2">
                    <span class="h-px w-full bg-proffeo-on-action/20"></span>
                    <p class="text-nowrap text-base text-proffeo-on-action">
                      {{ companyMenu.titleTranslationKey | translate }}
                    </p>
                    <span class="h-px w-full bg-proffeo-on-action/20"></span>
                  </div>
                </div>
                <div class="flex flex-col justify-center gap-2">
                  @for (item of companyMenu.children; track $index) {
                    <div
                      (click)="handleNavigationClick()"
                      [ngClass]="isMenuItemActive(item.link) ? 'opacity-100' : 'opacity-75'"
                      [routerLink]="$safeNavigationMigration(item?.link)"
                      [routerLinkActiveOptions]="{
                        exact: item.exactMatch ?? false
                      }"
                      routerLinkActive
                      class="group flex h-[38px] cursor-pointer items-center gap-2 hover:opacity-100"
                    >
                      <mat-icon
                        [fontIcon]="item.icon"
                        [class.opacity-100]="isMenuItemActive(item.link)"
                        class="transition-all! opacity-75 group-hover:opacity-100 icon-white"
                      />
                      <p class="truncate text-nowrap text-proffeo-on-action">
                        {{ item.titleTranslationKey | translate }}
                      </p>
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        </div>
      }

      <!-- DESKTOP: pinned pushes layout; hover peek overlays content -->
      <div
        [class.is-pinned]="pinned()"
        aria-hidden="true"
        class="layout-desktop-sidebar-spacer"
      ></div>

      <div
        (mouseenter)="turnOffMenuAutoclose()"
        (mouseleave)="triggerMenuAutoclose($event)"
        [class.is-expanded]="visuallyExpanded()"
        [class.scrollbar-hide]="!visuallyExpanded()"
        class="menu-wrapper layout-desktop-sidebar absolute top-0 left-0 z-120 hidden h-dvh flex-col gap-6 overflow-y-auto overflow-x-hidden border-r border-proffeo-overlay-subtle bg-proffeo-surface-inverse px-2 pl-3 shadow-r md:flex"
      >
        <div class="flex flex-col gap-5 py-5">
          <button
            (click)="toggleMenu()"
            [attr.aria-label]="
              (pinned() ? 'layout-desktop-sidebar-collapse' : 'layout-desktop-sidebar-expand') | translate
            "
            type="button"
            class="group cursor-pointer border-0 bg-transparent p-0 mr-auto"
          >
            <mat-icon
              [fontIcon]="pinned() ? 'menu_open' : 'menu'"
              class="transition-all! opacity-75 group-hover:opacity-100 icon-white"
            />
          </button>
          <div class="group flex h-[38px] items-center gap-2">
            <mat-icon
              fontIcon="domain"
              class="icon-white shrink-0"
            />
            <div
              [attr.aria-hidden]="!visuallyExpanded()"
              class="layout-sidebar-detail"
            >
              <ng-container *ngTemplateOutlet="layoutCompanySelect" />
            </div>
          </div>

          @if (projects()?.length > 0 && activeCompany()) {
            <div class="group flex h-[38px] items-center gap-2">
              <mat-icon
                fontIcon="task_alt"
                class="icon-white shrink-0"
              />
              <div
                [attr.aria-hidden]="!visuallyExpanded()"
                class="layout-sidebar-detail"
              >
                <ng-container *ngTemplateOutlet="layoutProjectSelect" />
              </div>
            </div>
          }
        </div>

        <!--        App Section-->
        <div class="flex h-full w-full flex-col gap-5">
          @if (dashboardMenuItems(); as dashboardMenu) {
            <div class="flex flex-col justify-center gap-2">
              <div class="flex h-[21px] w-full items-center justify-center gap-2 opacity-75">
                <div class="layout-sidebar-detail flex h-full w-full items-center justify-center gap-2">
                  <span class="h-px w-full bg-proffeo-on-action/20"></span>
                  <p class="text-nowrap text-base text-proffeo-on-action">
                    {{ dashboardMenu.titleTranslationKey | translate }}
                  </p>
                  <span class="h-px w-full bg-proffeo-on-action/20"></span>
                </div>
              </div>
              <div class="flex flex-col justify-center gap-2">
                @for (item of dashboardMenu.children; track $index) {
                  <div
                    [ngClass]="{
                      'cursor-pointer hover:opacity-100 opacity-75': !item.disabled,
                      'opacity-30 cursor-default': item.disabled,
                      'opacity-100': isMenuItemActive(item.link)
                    }"
                    [routerLink]="item.disabled ? null : item.link"
                    [routerLinkActiveOptions]="{ exact: item.exactMatch ?? false }"
                    [matTooltip]="item.disabled ? (item.disabledTooltipTranslationKey | translate) : ''"
                    [matTooltipDisabled]="!item.disabled"
                    routerLinkActive
                    class="group flex h-[38px] cursor-pointer items-center gap-2"
                  >
                    <mat-icon
                      [fontIcon]="item.icon"
                      [class.opacity-100]="isMenuItemActive(item.link)"
                      class="icon-white shrink-0"
                    />
                    <p class="layout-sidebar-detail truncate text-nowrap text-proffeo-on-action">
                      {{ item.titleTranslationKey | translate }}
                    </p>
                  </div>
                }
              </div>
            </div>
          }

          <!--          Project section-->
          @if (activeProjectMenuItems(); as projectMenu) {
            <div class="flex flex-col justify-center gap-2">
              <div class="flex h-[21px] w-full items-center justify-center gap-2 opacity-75">
                <div class="layout-sidebar-detail flex h-full w-full items-center justify-center gap-2">
                  <span class="h-px w-full bg-proffeo-on-action/20"></span>
                  <p class="text-nowrap text-base text-proffeo-on-action">
                    {{ projectMenu.titleTranslationKey | translate }}
                  </p>
                  <span class="h-px w-full bg-proffeo-on-action/20"></span>
                </div>
              </div>
              <div class="flex flex-col justify-center gap-2">
                @for (item of projectMenu.children; track $index) {
                  <div
                    [ngClass]="isMenuItemActive(item.link) ? 'opacity-100' : 'opacity-75'"
                    [routerLink]="$safeNavigationMigration(item?.link)"
                    [routerLinkActiveOptions]="{
                      exact: item.exactMatch ?? false
                    }"
                    routerLinkActive
                    class="group flex h-[38px] cursor-pointer items-center gap-2 hover:opacity-100"
                  >
                    <mat-icon
                      [fontIcon]="item.icon"
                      [class.opacity-100]="isMenuItemActive(item.link)"
                      class="icon-white shrink-0"
                    />
                    <p class="layout-sidebar-detail truncate text-nowrap text-proffeo-on-action">
                      {{ item.titleTranslationKey | translate }}
                    </p>
                  </div>
                }
              </div>
            </div>
          }

          <!--          Company Section-->
          @if (activeCompanyMenuItems(); as companyMenu) {
            <div class="flex flex-col justify-center gap-2">
              <div class="flex h-[21px] w-full items-center justify-center gap-2 opacity-75">
                <div class="layout-sidebar-detail flex h-full w-full items-center justify-center gap-2">
                  <span class="h-px w-full bg-proffeo-on-action/20"></span>
                  <p class="text-nowrap text-proffeo-on-action">
                    {{ companyMenu.titleTranslationKey | translate }}
                  </p>
                  <span class="h-px w-full bg-proffeo-on-action/20"></span>
                </div>
              </div>
              <div class="flex flex-col justify-center gap-2">
                @for (item of companyMenu.children; track $index) {
                  <div
                    [ngClass]="isMenuItemActive(item.link) ? 'opacity-100' : 'opacity-75'"
                    [routerLink]="$safeNavigationMigration(item?.link)"
                    [routerLinkActiveOptions]="{
                      exact: item.exactMatch ?? false
                    }"
                    routerLinkActive
                    class="group flex h-[38px] cursor-pointer items-center gap-2 hover:opacity-100"
                  >
                    <mat-icon
                      [fontIcon]="item.icon"
                      [class.opacity-100]="isMenuItemActive(item.link)"
                      class="icon-white shrink-0"
                    />
                    <p class="layout-sidebar-detail truncate text-nowrap text-proffeo-on-action">
                      {{ item.titleTranslationKey | translate }}
                    </p>
                  </div>
                }
              </div>
            </div>
          }
        </div>

        <div
          class="bg-proffeo-surface-inverse sticky bottom-0 z-10 flex flex-col items-center gap-3 border-t border-proffeo-base-50/10 py-3"
        >
          <div
            [matMenuTriggerFor]="userMenu"
            class="flex gap-2 items-center group cursor-pointer min-w-0 w-full"
          >
            <mat-icon
              fontIcon="account_circle"
              class="opacity-75 group-hover:opacity-100 icon-white shrink-0"
            />
            <div class="layout-sidebar-detail">
              <p class="truncate text-nowrap text-proffeo-on-action opacity-75 group-hover:opacity-100">
                {{ currentUser()?.fullName }}
              </p>
            </div>
          </div>
          <proffeo-lang-toggle [expanded]="visuallyExpanded()"></proffeo-lang-toggle>
        </div>
      </div>
    }
    <div
      [proffeoSpinner]="loading()"
      cdkScrollable
      proffeoSpinnerSize="md"
      class="app-content relative flex-1 overflow-y-auto bg-proffeo-surface-page w-full"
    >
      <div class="flex flex-col h-full">
        @if (isAuthenticated() && !isMobile()) {
          <proffeo-active-timer-bar></proffeo-active-timer-bar>
        }
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>

<mat-menu #userMenu="matMenu">
  @if (currentUser(); as user) {
    <div class="flex flex-col">
      <div class="flex w-full flex-col gap-1 px-4 py-2">
        <p class="font-semibold">{{ 'layout-user-signed-in-as' | translate }}</p>
        <p>{{ user.email }}</p>
      </div>
      @if (isMobile()) {
        <div
          (click)="langToggle.openMenu($event)"
          class="flex w-full items-center gap-2 px-4 py-2 hover:bg-proffeo-accent hover:text-proffeo-on-action cursor-pointer transition-default group"
        >
          <proffeo-lang-toggle
            #langToggle
            class="w-6"
          ></proffeo-lang-toggle>
          {{ 'layout-language' | translate }}
        </div>
      }
      <button class="hidden w-full items-center gap-2 px-4 py-2 hover:bg-proffeo-surface-hover">
        <mat-icon
          fontIcon="person"
          class="icon-md"
        />
        {{ 'layout-user-my-profile' | translate }}
      </button>
      <button class="hidden w-full items-center gap-2 px-4 py-2 hover:bg-proffeo-surface-hover">
        <mat-icon
          fontIcon="settings"
          class="icon-md"
        />
        {{ 'layout-user-settings' | translate }}
      </button>
      <button
        routerLink="/user-profile"
        class="flex w-full items-center gap-2 px-4 py-2 hover:bg-proffeo-accent hover:text-proffeo-on-action cursor-pointer transition-default group"
      >
        <mat-icon
          fontIcon="account_circle"
          class="group-hover:icon-white"
        />
        {{ 'user-profile-page.title' | translate }}
      </button>
      <button
        (click)="openChangePasswordDialog()"
        class="flex w-full items-center gap-2 px-4 py-2 hover:bg-proffeo-accent hover:text-proffeo-on-action cursor-pointer transition-default group"
      >
        <mat-icon
          fontIcon="lock"
          class="group-hover:icon-white"
        />
        {{ 'change-password' | translate }}
      </button>
      <button
        routerLink="/sign-out"
        class="flex w-full items-center gap-2 px-4 py-2 hover:bg-proffeo-accent hover:text-proffeo-on-action cursor-pointer transition-default group"
      >
        <mat-icon
          fontIcon="logout"
          class="group-hover:icon-white"
        />
        {{ 'layout-user-sign-out' | translate }}
      </button>
    </div>
  }
</mat-menu>
